import { allPlanVars } from "./constants/purchase_constants";
import { tryCatchSafe } from "./utils/tryCatchUtils";
import { getCookie } from "./utils/common";

export const tiktokIdentify = async (id) => {
  const hashBuffer = await crypto?.subtle?.digest("SHA-256", new TextEncoder().encode(id));
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const SHA_256 = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
  window?.ttq?.identify({
    external_id: SHA_256 // string. Any unique identifier, such as loyalty membership IDs, user IDs, and external cookie IDs.It must be hashed with SHA-256 on the client side.
  });
};

export const trackAdEcomLinked = (hashedName, hashedBillingDetails) => {
  tryCatchSafe(() => window.ttq.track("ecom-linked", {}), "error ecom-linked  TikTok Pixel track");
  // tryCatchSafe(() => window.fbq("track", "ecom-linked"), "error ecom-linked track");
  try {
    // window.gtag("event", "ecom-linked", { send_to: "AW-396003452/99laCJWL4bYaEPyQ6rwB" });
    const fbc = getCookie("_fbc");
    const eventData = {
      event: "ecom_linked",
      user_email: hashedName, // need to discuss this
      ...(hashedBillingDetails?.customer_first_name && {
        fn: hashedBillingDetails?.customer_first_name
      }),
      ...(hashedBillingDetails?.customer_last_name && {
        ln: hashedBillingDetails?.customer_last_name
      }),
      ...(hashedBillingDetails?.city && {
        ct: hashedBillingDetails?.city
      }),
      ...(hashedBillingDetails?.postal_code && {
        zp: hashedBillingDetails?.postal_code
      }),
      ...(hashedBillingDetails?.country && {
        country: hashedBillingDetails?.country
      }),
      ...(hashedBillingDetails?.state && {
        st: hashedBillingDetails?.state
      })
    };
    if (fbc) {
      eventData.fbc = fbc;
    }
    window.dataLayer.push(eventData);
  } catch (error) {
    console.log("gtag error   ", error);
  }
  // try {
  //   window.gtag("event", "ecom-linked", { send_to: "G-PQJ6V7Z34C" });
  // } catch (error) {
  //   console.log("gtag error   ", error);
  // }
};

export const trackCCInitiate = (
  hashedName,
  planId,
  currencyCode,
  amountPaid,
  hashedBillingDetails
) => {
  try {
    const fbc = getCookie("_fbc");
    const eventData = {
      event: "ccadded",
      value: amountPaid,
      currency: currencyCode,
      user_email: hashedName,
      plan: planId,
      ...(hashedBillingDetails?.customer_first_name && {
        fn: hashedBillingDetails?.customer_first_name
      }),
      ...(hashedBillingDetails?.customer_last_name && {
        ln: hashedBillingDetails?.customer_last_name
      }),
      ...(hashedBillingDetails?.city && {
        ct: hashedBillingDetails?.city
      }),
      ...(hashedBillingDetails?.postal_code && {
        zp: hashedBillingDetails?.postal_code
      }),
      ...(hashedBillingDetails?.country && {
        country: hashedBillingDetails?.country
      }),
      ...(hashedBillingDetails?.state && {
        st: hashedBillingDetails?.state
      })
    };
    if (fbc) {
      eventData.fbc = fbc;
    }
    window.dataLayer.push(eventData);
  } catch (error) {
    console.log("gtag error   ", error);
  }
};

export const trackAdAutoPostStart = (hashedName, planId, hashedBillingDetails) => {
  try {
    const fbc = getCookie("_fbc");
    const eventData = {
      event: "autopost_start",
      user_email: hashedName,
      plan: planId,
      ...(hashedBillingDetails?.customer_first_name && {
        fn: hashedBillingDetails?.customer_first_name
      }),
      ...(hashedBillingDetails?.customer_last_name && {
        ln: hashedBillingDetails?.customer_last_name
      }),
      ...(hashedBillingDetails?.city && {
        ct: hashedBillingDetails?.city
      }),
      ...(hashedBillingDetails?.postal_code && {
        zp: hashedBillingDetails?.postal_code
      }),
      ...(hashedBillingDetails?.country && {
        country: hashedBillingDetails?.country
      }),
      ...(hashedBillingDetails?.state && {
        st: hashedBillingDetails?.state
      })
    };
    if (fbc) {
      eventData.fbc = fbc;
    }
    window.dataLayer.push(eventData);
  } catch (error) {
    console.log("gtag error   ", error);
  }
};

export const trackAdAutoPostActive = (hashedName, planId, hashedBillingDetails) => {
  try {
    const fbc = getCookie("_fbc");
    const eventData = {
      event: "autopost_active",
      user_email: hashedName,
      plan: planId,
      ...(hashedBillingDetails?.customer_first_name && {
        fn: hashedBillingDetails?.customer_first_name
      }),
      ...(hashedBillingDetails?.customer_last_name && {
        ln: hashedBillingDetails?.customer_last_name
      }),
      ...(hashedBillingDetails?.city && {
        ct: hashedBillingDetails?.city
      }),
      ...(hashedBillingDetails?.postal_code && {
        zp: hashedBillingDetails?.postal_code
      }),
      ...(hashedBillingDetails?.country && {
        country: hashedBillingDetails?.country
      }),
      ...(hashedBillingDetails?.state && {
        st: hashedBillingDetails?.state
      })
    };
    if (fbc) {
      eventData.fbc = fbc;
    }
    window.dataLayer.push(eventData);
  } catch (error) {
    console.log("gtag error   ", error);
  }
};
//left
export const trackAdSignup = (username) => {
  tryCatchSafe(() => window.ttq.track("signup", {}), "error in Tiktok Pixel signup");
  try {
    // window.gtag("event", "signup_success", { send_to: "AW-396003452/P0snCNba0ZYaEPyQ6rwB" });
    const fbc = getCookie("_fbc");
    const eventData = {
      event: "signup",
      user_email: username
    };
    if (fbc) {
      eventData.fbc = fbc;
    }
    window.dataLayer.push(eventData);
  } catch (error) {
    console.log("gtag error  ", error);
  }

  try {
    window.gtag("event", "signup_success", { send_to: "G-PQJ6V7Z34C" });
  } catch (error) {
    console.log("gtag error  ", error);
  }
};

export const trackAdInitiateCheckout = (hashedName, hashedBillingDetails) => {
  tryCatchSafe(
    () => window.ttq.track("InitiateCheckout", {}),
    "error in tiktok Pixel checkout tracking"
  );
  // tryCatchSafe(() => window.fbq("track", "InitiateCheckout"), "error in checkout tracking");
  // tryCatchSafe(
  //   () =>
  //     window.gtag("event", "conversion", {
  //       send_to: "AW-396003452/3CSKCPnBp6QDEPyQ6rwB", // ad initiateCheckout
  //       value: 2000.0,
  //       currency: "INR"
  //     }),
  //   "error in gtag checkout tracking"
  // );
  tryCatchSafe(() => {
    const fbc = getCookie("_fbc");
    const eventData = {
      event: "initiate_checkout",
      user_email: hashedName,
      value: 2000.0,
      currency: "INR",
      ...(hashedBillingDetails?.customer_first_name && {
        fn: hashedBillingDetails?.customer_first_name
      }),
      ...(hashedBillingDetails?.customer_last_name && {
        ln: hashedBillingDetails?.customer_last_name
      }),
      ...(hashedBillingDetails?.city && {
        ct: hashedBillingDetails?.city
      }),
      ...(hashedBillingDetails?.postal_code && {
        zp: hashedBillingDetails?.postal_code
      }),
      ...(hashedBillingDetails?.country && {
        country: hashedBillingDetails?.country
      }),
      ...(hashedBillingDetails?.state && {
        st: hashedBillingDetails?.state
      })
    };
    if (fbc) {
      eventData.fbc = fbc;
    }
    window.dataLayer.push(eventData);
  }, "error in gtag checkout tracking");
};

export const trackAdAfterPurchase = (props) => {
  const {
    username = "",
    amountPaid = 32,
    currency_code = "USD",
    planId = allPlanVars.core,
    firebaseUid = "",
    linkedinId = "",
    hashedName = "",
    hashedBillingDetails = {}
  } = props;
  tryCatchSafe(() => window.fpr("referral", { email: username }));
  tryCatchSafe(() =>
    window.ttq.track("CompletePayment", {
      value: amountPaid,
      currency: currency_code
    })
  );
  // tryCatchSafe(() =>
  //   window.fbq("track", "Purchase", {
  //     value: amountPaid,
  //     currency: currency_code,
  //     external_id: firebaseUid
  //   })
  // );
  // try {
  //   window.gtag("event", "conversion", {
  //     send_to: "AW-396003452/-zN1CNuJ8KEDEPyQ6rwB", //ad
  //     value: amountPaid,
  //     currency: currency_code,
  //     transaction_id: firebaseUid
  //   });
  // } catch (error) {
  //   SentryCaptureException(error);
  // }
  // try {
  //   window.gtag("event", "purchase", {
  //     send_to: "G-PQJ6V7Z34C", //analytics
  //     value: amountPaid,
  //     currency: currency_code,
  //     transaction_id: firebaseUid
  //   });
  // } catch (error) {
  //   SentryCaptureException(error);
  // }
  tryCatchSafe(() => {
    const fbc = getCookie("_fbc");
    const eventData = {
      event: "purchase",
      user_email: hashedName,
      value: amountPaid,
      currency: currency_code,
      transaction_id: firebaseUid,
      ...(hashedBillingDetails?.customer_first_name && {
        fn: hashedBillingDetails?.customer_first_name
      }),
      ...(hashedBillingDetails?.customer_last_name && {
        ln: hashedBillingDetails?.customer_last_name
      }),
      ...(hashedBillingDetails?.city && {
        ct: hashedBillingDetails?.city
      }),
      ...(hashedBillingDetails?.postal_code && {
        zp: hashedBillingDetails?.postal_code
      }),
      ...(hashedBillingDetails?.country && {
        country: hashedBillingDetails?.country
      }),
      ...(hashedBillingDetails?.state && {
        st: hashedBillingDetails?.state
      })
    };
    if (fbc) {
      eventData.fbc = fbc;
    }
    window.dataLayer.push(eventData);
  }, "error in gtag purchase tracking");
  tryCatchSafe(() =>
    window.lintrk("track", {
      conversion_id: linkedinId
    })
  );
};
